import React, { useEffect, useContext, useState } from "react";
import styled from "styled-components";
import AddressInput from "./AddressInput";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import SelectMultiAutocomplete from "common/SelectMultiAutocomplete";
import NumberInput from "common/NumberInputWithSpinnerState";

const ControlsAndResultsLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 10px;
`;

const SelectsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  .addressSelect {
    width: 310px;
  }
  .typesSelect {
    width: 350px;
  }
  .meanThresholdSelect {
    width: 300px;
  }
`;

const SelectWrapper = styled.div`
  width: 150px;
  margin: 0 10px;
`;

const _directionOptions = [
    { label: "Downlink", value: "downlink" },
    { label: "Uplink", value: "uplink" },
  ];
  
  const _timePeriodOptions = [
    { label: "1 Day", value: "oneDay" },
    { label: "1 Week", value: "oneWeek" },
    { label: "1 Month", value: "oneMonth" },
    { label: "3 Months", value: "threeMonths" },
  ];
  
  const _metricOptions = [
    { label: "Average Speed", value: "averageSpeed" },
    { label: "Active Flows", value: "activeFlows" },
    { label: "Active Subscribers", value: "activeSubscribers" },
    { label: "Flows Created Per Minute", value: "flowsCreated" },
    { label: "Latency", value: "latency" },
    { label: "Retransmissions", value: "retransmissions" },
    { label: "Congestion", value: "congestion" },
  ];
  
  const _useOptions = [
    { label: "Use filtered IP for metrics", value: "ipAddress" },
    { label: "Use subs-id for filtered IP", value: "subsId" },
  ];

const FilteringControls = ({settings, onChange, groupTypes, thresholds, setThresholds}) => {
  const handleChange = (event) => {
    const { target } = event;
    const value =
      target.type !== "checkbox"
        ? target.value
        : target.value === "on" && target.checked === true;
        onChange({ ...settings, [target.name]: value });
  };

  const optionsTypesSet = new Set(Object.values(groupTypes));

  return (
    <ControlsAndResultsLayout>
      <SelectsWrapper>
        <SelectWrapper>
          <SelectInputWithIcon
            title="Direction"
            name="direction"
            icon="import_export"
            selected={settings.direction}
            onChange={handleChange}
            options={_directionOptions}
          />
        </SelectWrapper>
        <SelectsWrapper className="addressSelect">
          <AddressInput
            value={settings.ipAddress}
            name="ipAddress"
            onChange={handleChange}
            allowIpRanges={false}
          />
        </SelectsWrapper>
        <SelectWrapper>
          <SelectInputWithIcon
            title="Time Period"
            name="timePeriod"
            icon="date_range"
            selected={settings.timePeriod}
            onChange={handleChange}
            options={_timePeriodOptions}
          />
        </SelectWrapper>
        <SelectWrapper>
          <SelectInputWithIcon
            title="metric"
            name="metric"
            icon="insert_chart"
            selected={settings.metric}
            onChange={handleChange}
            options={_metricOptions}
          />
        </SelectWrapper>
        {settings.ipAddress ? (
          <SelectWrapper>
            <SelectInputWithIcon
              title="use"
              name="use"
              icon="label_outline"
              selected={settings.use}
              onChange={handleChange}
              options={_useOptions}
            />
          </SelectWrapper>
        ) : null}
        <SelectWrapper className="typesSelect">
          <SelectMultiAutocomplete
            icon="group"
            title="Group Type"
            name="group-type-selector"
            placeholder="Group Type"
            className="group-type-selector"
            options={[...optionsTypesSet].map((type) => {
              return { label: type, value: type };
            })}
            key={JSON.stringify([...optionsTypesSet])}
            onChange={(value) =>
              onChange({
                ...settings,
                types: value.map((optionType) => optionType.value),
              })
            }
          />
        </SelectWrapper>
        <SelectWrapper className="meanThresholdSelect">
          <MeanThreshold
            thresholds={thresholds}
            setThresholds={setThresholds}
          />
        </SelectWrapper>
      </SelectsWrapper>
    </ControlsAndResultsLayout>
  );
};

export default FilteringControls;

const WrapperMeanThreshold = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
`;

const LabelApply = styled.div`
  margin-left: 20px;
  cursor: pointer;
`;

const WrapperError = styled.div`
 color: red;
 font-size: 11px;
`;

const MeanThreshold = ({thresholds, setThresholds}) => {
  const [mean, setMean] = useState();
  const [error, setError] = useState(null);

  useEffect(()=>{
setMean(thresholds["MEAN-Mbps"])
  }, [JSON.stringify(thresholds)])
  const handleChange = (value)=> {
    if (isNaN(value) === true) {
      setError("Must specify a float number higher than zero.");
    } else {
      setError(null);
      setMean(value);
    }
  }
  const handleApply = ()=>{
    ifCl
      .run(`configure\npkteng\nmetrics threshold mean-mbps ${mean}\ncommit\n`, true)
      .then(() => setThresholds({ ...thresholds, ["MEAN-Mbps"]: mean}))
      .catch((error) => setError("Error:", error));
  }

  return (
    <div>
      <WrapperMeanThreshold>
        <NumberInput
          initialValue={mean}
          name={"mean-mbps-threshold"}
          label={"MEAN-Mbps warning threshold"}
          onChange={handleChange}
          hideSpinner={true}
          hideReset={true}
        />
        <LabelApply onClick={handleApply}>Apply</LabelApply>
      </WrapperMeanThreshold>
      {error ? <WrapperError>{error}</WrapperError> : null}
    </div>
  );
};